import React from "react";

import { titleTranslation } from "data/about/translationAbout";
import { useLanguagesContext } from "hooks/useContextAll";

import PageTitle from "components/PageTitle";
import PageDirection from "components/PageDirection";

import AboutIntro from "./AboutIntro";
import AboutContent from "./AboutContent";

const AboutView = () => {
    const language = useLanguagesContext();

    return (
        <>
            <PageTitle text={titleTranslation[language.language]} />
            <PageDirection>
                <AboutIntro language={language.language} />
                <AboutContent language={language.language} />
            </PageDirection>
        </>
    );
};

export default AboutView;
